import * as React from "react";
const SvgFiRrSport = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-sport_svg__a)">
      <path d="M12.014 24H6a6.006 6.006 0 0 1-6-6v-2.838A6 6 0 0 1 7.236 9.29L20.01 11.98 21.881.835a1 1 0 1 1 1.973.33L21.4 15.8a9.3 9.3 0 0 1-.667 2.51A9.52 9.52 0 0 1 12.014 24m-6.02-12.84a4 4 0 0 0-3.994 4V18a4 4 0 0 0 4 4h6.014a7.52 7.52 0 0 0 6.886-4.492c.266-.643.441-1.32.521-2.01l.259-1.544-12.856-2.706a4 4 0 0 0-.83-.087" />
      <path d="M14.517 17.058q-.105 0-.207-.021L5.8 15.252a1 1 0 1 1 .41-1.952l8.51 1.785a1 1 0 0 1-.2 1.978zM10 20.28a1 1 0 0 1-.208-.023l-4.962-1.05a1 1 0 0 1 .414-1.957l4.963 1.05A1 1 0 0 1 10 20.28" />
    </g>
    <defs>
      <clipPath id="fi-rr-sport_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSport;
